import React from 'react'
import { Link } from 'react-router-dom'

import articles from './articles'

const HelpHome = () => {
  return [
    <div className="breadcrumb">
      <div className="container">
        <Link to="/help">Ayuda</Link>
      </div>
    </div>,
    <section className="help-home">
      <div className="container">
        <h2>Temas de Ayuda</h2>
        <ul className="items">
          { articles.map((article, index) => (
            <Link
              key={index}
              to={`/help/${article.name}`}>
              <li>{article.title}</li>
            </Link>
          ))}
        </ul>
      </div>
    </section>
  ]
}

export default HelpHome
